module.exports = __webpack_public_path__ + "img/tech 3.07d934a4.png";